import React, { useState, useEffect } from "react";

import { SAdefaultValues, selectDateOrTime } from "../../../../services/saleAnalysis-services";
import {
    Button,
    Chip,
    colors,
    Container,
    Dialog,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";
import { uri } from "../../../../help/Api";
import { useHistory } from "react-router-dom";
import {
    useStylesHed,
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../../St/comps/UseStyle";
import { insh as inshst } from "../../../../Context/InshSt";
import ScannerIcon from "@material-ui/icons/Scanner";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import moment from "moment";
import axios from "axios";

import ReplyIcon from "@material-ui/icons/Reply";
import deepRenameKeys from "deep-rename-keys";
import CustomersSearchForm from "./CustomersSearchForm";
import CustomersSearchTable from "./CustomersSearchTable";
import useFetchObjectByPost from "../../../../components/Hooks/useFetchObjectByPost";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: "#faf1f1",
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },

    headerTitle: {
        backgroundColor: colors.red[30],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        fontWeight: "bold"
    },


    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: "#d3d3d3",
        borderColor: "#808080",
    },
}));

export default function CustomersSearch(props) {
    const { openSearchMdl, handCloseDw,
        onRowClick, type: type, optionsUsers, transition,
    } = props;
    const TYPEACIVE = [
        { id: -1, name: "الكل" },
        { id: 0, name: "النشطيين" },
        { id: 1, name: "الموقفين" },
    ];
    const initialSearchObject = {
        users: optionsUsers[0]??0,
        name: "",
        acc_no: "",
        notes: "",
        type: type,
        vat_num: '',
        address: '',
        mobile: '',
        type_active:TYPEACIVE[0],
    };


    const [rptParams, setRptParams] = React.useState(initialSearchObject);
    const classes = useStyles();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const { t } = useTranslation(["forms", "translation"]);

    const [data, setData] = useState([]);
    const [fetching, setFetching] = useState(false);
    const viewHandle = async () => {

        setData([]);
        setFetching(true);
        await axios
            .get(
                uri +
                `Customers/CustomersSearch?type=${rptParams?.type}
        &&customer_name=${rptParams?.name}
        &&acc_no=${rptParams?.acc_no}
        &&mobile=${rptParams.mobile}
        &&address=${rptParams?.address}
       &&vat_num=${rptParams?.vat_num}
        &&users=${rptParams?.users?.id}`
            )
            .then((res) => {
                if (rptParams.type_active?.id==-1){
                    setData(res.data?.custData);
                }else{
                    var otherOptions = res.data?.custData.filter((obj) => obj.stop_trans??0 == rptParams.type_active?.id??0);
                    setData(otherOptions);
                }
                // console.log(" the data is", res.data);
                setFetching(false);
            })
            .catch((err) => {
                ViewHandle2();
            });
    };

    const ViewHandle2 = (rowData) => {

        setData([]);
        setFetching(true);
        const tb = {
            CustomersWTypes: true,
            parms: {
                id: type,
                icustmtype: type,
            },
        };

        axios
            .post(uri + "Res", tb)
            .then((res) => {
                setFetching(false);
                setData(res.data?.Customers);
            })
            .catch((error) => {
            });
    };

    const his = useHistory();


    let excel_name = "Customers";
    var columns = [
        { title: "", field: "id", hidden: true },
        { title: "الإسم", field: "name", },
        { title: "الرقم الضريبي", field: "tax_no", },
        { title: "رقم الهاتف", field: "tel", },
        { title: "رقم الجوال", field: "mobile", },
        { title: "الدولة", field: "country", },
        { title: "المدينة", field: "city", },
        { title: "المنطقة", field: "area", },
        { title: "رقم الحساب في الدليل", field: "acc_no", },
        { title: "رقم الهوية", field: "national_id", },
        { title: "ملاحطلات", field: "notes", },
    ];

    const excelHeaders = deepRenameKeys(columns, (key) => {
        if (key === "field") return "key";
        if (key === "title") return "label";
    });

    useEffect(() => {
        console.log("the data is", rptParams);
    });

    const onChangeData = (propName) => (event) => {
        setRptParams({ ...rptParams, [propName]: event.target.value });
    };
    const onChangeAutoData = (propName, newValue) => {
        setRptParams({ ...rptParams, [propName]: newValue });
    };

    const [style, setStyle] = useState(inshst.custm);

    return (
        <Dialog
            fullScreen
            open={openSearchMdl}
            onClose={handCloseDw}
            TransitionComponent={transition}
            key={transition ? transition.name : ""}
        >
            <div className={classes.root}>
                <Grid container item xs={12}>
                    <Typography
                        size="small"
                        className={classes.headerTitle}
                        color="primary"
                    >
                        {type == 1 ? " البـحـث فـي العملاء " : "البحث في الموردين"}
                    </Typography>
                </Grid>
                <Typography
                    component="div"
                    style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
                >
                    <Container
                        component={Paper}
                        maxWidth={false}
                        style={{
                            padding: "10px",
                            paddingBottom: "0px",
                            borderBottomColor: "#808080",
                            borderBottomWidth: "1px",
                            borderBottomStyle: "solid",
                        }}
                    >
                        <CustomersSearchForm
                            {...{
                                type,
                                rptParams,
                                onChangeData,
                                onChangeAutoData,
                                optionsUsers,
                                type,
                                TYPEACIVE
                            }}
                        />
                        <Grid
                            container
                            justifyContent="center"
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            spacing={1}
                        >
                            <Hidden smUp={["sm"]}>
                                <Grid item>
                                    <Button
                                        disabled={fetching}
                                        variant="contained"
                                        startIcon={<ScannerIcon />}
                                        size="large"
                                        style={{ ...style.iconBtn, borderRadius: 0 }}
                                        className={[clasui.button]}
                                        onClick={() => viewHandle()}
                                    >
                                        {t("forms:show")}
                                    </Button>
                                </Grid>
                            </Hidden>
                            <Hidden only={["xs"]}>
                                <Grid item>
                                    <Button
                                        disabled={fetching}
                                        variant="contained"
                                        startIcon={<ScannerIcon />}
                                        size="large"
                                        style={{ ...style.iconBtn, borderRadius: 0 }}
                                        className={[clasui.button]}
                                        onClick={() => viewHandle()}
                                    >
                                        {t("forms:view")}
                                    </Button>
                                </Grid>
                            </Hidden>
                            <Hidden smUp={["sm"]}>

                                <Grid item >
                                    {data && !fetching && (
                                        <CSVLink
                                            separator={";"}
                                            filename={excel_name}
                                            data={data}
                                            headers={excelHeaders}
                                        >
                                            {" "}
                                            <Button
                                                disabled={fetching}
                                                variant="contained"
                                                startIcon={<TableChart />}
                                                size="large"
                                                color="primary"
                                                style={{ ...style.iconBtn, borderRadius: 0 }}
                                                className={[clasui.button]}
                                            >
                                                {"اكسل"}
                                            </Button>
                                        </CSVLink>
                                    )}
                                </Grid>
                            </Hidden>
                            <Hidden only={["xs"]}>
                                <Grid item >
                                    {data && !fetching && (
                                        <CSVLink
                                            separator={";"}
                                            filename={excel_name}
                                            data={data}
                                            headers={excelHeaders}
                                        >
                                            {" "}
                                            <Button
                                                disabled={fetching}
                                                variant="contained"
                                                startIcon={<TableChart />}
                                                size="large"
                                                color="primary"
                                                style={{ ...style.iconBtn, borderRadius: 0 }}
                                                className={[clasui.button]}
                                            >
                                                {"تصدير اكسل"}{" "}
                                            </Button>
                                        </CSVLink>
                                    )}
                                </Grid>
                            </Hidden>

                            <Grid item>
                                <Button
                                    variant="contained"
                                    // startIcon={<KeyboardReturnSharpIcon />}
                                    startIcon={<ReplyIcon />}
                                    color="secondary"
                                    size="large"
                                    aria-label="open drawer"
                                    className={[clasui.button, clasSp.clcan]}
                                    style={
                                        (inshst.sal.iconBtn,
                                            { borderRadius: 0 })
                                    }
                                    onClick={() => handCloseDw()}
                                >
                                    {/* {t("forms:exit")} */}
                                    {"رجوع"}
                                </Button>
                            </Grid>
                        </Grid>
                    </Container>

                    <br />
                    <Container
                        component={Paper}
                        maxWidth={false}
                        style={{
                            paddingRight: "5px",
                            paddingLeft: "5px",
                        }}
                    >
                        <Grid container justifyContent="center">
                            <Grid item container justifyContent="center" xs={12}>
                                <BeatLoader loading={fetching} color="#81007f" />
                                {!fetching && (
                                    <CustomersSearchTable
                                        {...{
                                            //  data: data ? data : [],
                                            data: data ? data : [],
                                            onRowClick, rptParams,
                                            type
                                        }}
                                    />
                                )}
                            </Grid>
                        </Grid>
                    </Container>
                </Typography>
            </div>
        </Dialog>
    );
}
